module.exports = __webpack_public_path__ + "static/media/tabela.76f214a5.png";